import { SimpleList } from "@/components/list";

export const FAQS = [
  {
    title: "What is the difference between NOC and SOC?",
    content: (
      <SimpleList
        points={[
          "NOC ensures network uptime, performance, and availability, focusing on infrastructure monitoring.",
          "SOC focuses on cybersecurity, threat detection, and incident response to prevent breaches.",
        ]}
      />
    ),
  },
  {
    title: "How does outsourcing NOC & SOC benefit businesses?",
    content: (
      <SimpleList
        points={[
          "Reduces IT costs by eliminating the need for an in-house monitoring team.",
          "Provides 24/7 expert support for real-time security and network management.",
          "Minimizes downtime with proactive incident response and issue resolution.",
        ]}
      />
    ),
  },
  {
    title: "How does AI-powered security improve SOC services?",
    content: (
      <SimpleList
        points={[
          "AI-driven threat detection identifies potential risks before they escalate.",
          "Automated security responses block attacks in real-time.",
          "Predictive analytics detect vulnerabilities and prevent breaches proactively.",
        ]}
      />
    ),
  },
  {
    title: "What industries benefit from managed NOC & SOC services?",
    content: (
      <SimpleList
        points={[
          "Finance & Banking – Secure transactions & fraud prevention.",
          "Healthcare – HIPAA-compliant data protection.",
          "Retail & E-commerce – Secure payment processing & DDoS protection.",
          "Enterprise IT – Scalable network security & compliance management.",
        ]}
      />
    ),
  },
  {
    title: "What is included in IT Helpdesk support?",
    content: (
      <SimpleList
        points={[
          "Troubleshooting software, hardware, and network issues.",
          "Remote assistance for quick resolution of user problems.",
          "Password resets, access management, and IT guidance.",
        ]}
      />
    ),
  },
  {
    title: "How does NOC improve network reliability?",
    content: (
      <SimpleList
        points={[
          "Monitors real-time performance metrics to prevent failures.",
          "Optimizes bandwidth and load balancing to reduce congestion.",
          "Ensures automated failover & disaster recovery for high availability.",
        ]}
      />
    ),
  },
  {
    title: "What cybersecurity threats does SOC protect against?",
    content: (
      <SimpleList
        points={[
          "Ransomware & malware attacks.",
          "Phishing & social engineering attempts.",
          "DDoS attacks & network intrusions.",
          "Insider threats & data breaches.",
        ]}
      />
    ),
  },
  {
    title: "How does NOC help with network scalability?",
    content: (
      <SimpleList
        points={[
          "Monitors network load and capacity to anticipate scaling needs.",
          "Implements automated traffic management for growing user demands.",
          "Ensures seamless integration of new devices and cloud services.",
        ]}
      />
    ),
  },
  {
    title: "What is SIEM, and why is it essential for SOC?",
    content: (
      <SimpleList
        points={[
          "Security Information and Event Management (SIEM) aggregates security logs.",
          "Uses AI-driven analytics to detect anomalies and potential breaches.",
          "Provides real-time threat intelligence for fast incident response.",
        ]}
      />
    ),
  },
  {
    title: "How does NOC reduce Mean Time to Resolution (MTTR)?",
    content: (
      <SimpleList
        points={[
          "Automates alerting and diagnostics to identify root causes quickly.",
          "Uses AI-driven predictive analytics to resolve issues before they escalate.",
          "Maintains real-time collaboration between engineers and IT teams.",
        ]}
      />
    ),
  },
  {
    title: "Can businesses customize their NOC & SOC services?",
    content: (
      <SimpleList
        points={[
          "Yes! Services can be tailored to industry-specific security, compliance, and monitoring needs.",
          "Flexible scaling options allow businesses to expand services as they grow.",
          "Custom alerting thresholds to match business risk tolerance.",
        ]}
      />
    ),
  },
  {
    title: "What role does a Helpdesk play in cybersecurity?",
    content: (
      <SimpleList
        points={[
          "Educates employees on phishing and social engineering attacks.",
          "Manages endpoint security policies to prevent unauthorized access.",
          "Provides real-time support for incident response and security patches.",
        ]}
      />
    ),
  },
  {
    title: "How does SOC handle insider threats?",
    content: (
      <SimpleList
        points={[
          "Behavioral analytics detect unusual login activity and access attempts.",
          "Zero-trust policies enforce least-privilege access controls.",
          "Automated alerts flag unauthorized data access and suspicious movements.",
        ]}
      />
    ),
  },
  {
    title: "What are the biggest cybersecurity threats SOC protects against?",
    content: (
      <SimpleList
        points={[
          "Ransomware & malware infiltrations.",
          "Phishing attacks and credential theft.",
          "DDoS attacks that disrupt operations.",
          "Cloud misconfiguration risks leading to data exposure.",
        ]}
      />
    ),
  },
];
